module.exports = __webpack_public_path__ + "static/media/line.22ecc9a7.svg";